import {CtlComEnum} from "@/main-page/enums/ctlComEnum";
import {unref, inject} from "vue";
import {isVuexTotalDefaultSet} from "@/main-page/ctls/hooks/useVuexState";


interface FormDsInt {
  elConfig?: any,
  vuexState?: any
  initDefValFlag?: any;
  model: any;
  initDefValue?: any,
  props?: any;
  pModelObj?: any;
  componentKey?: string;
  pItemType?: string;
}

export function useFormElDesHook({
                                   initDefValFlag,
                                   vuexState,
                                   initDefValue,
                                   model,
                                   props = {},
                                   pModelObj,
                                   componentKey = '',
                                   pItemType = ''
                                 }: FormDsInt) {

  /** 查询表单：自定义方案下禁止用页面字段默认值回填，保证与方案表单值隔离 */
  const allowFieldDefaults = inject('queryFormAllowFieldDefaults', true);

  const defaultSetVuexStr = unref(props)?.defaultSetVuex;
  const isVuexTotalDefault = isVuexTotalDefaultSet(defaultSetVuexStr);
  const hasDefaultConfig = !!(
    defaultSetVuexStr ||
    unref(props)?.defaultValue ||
    (unref(vuexState) && unref(vuexState)[CtlComEnum.DEFAULT_SET] != null && unref(vuexState)[CtlComEnum.DEFAULT_SET] !== '')
  );

  if (hasDefaultConfig) {
    onMounted(() => {
      if (unref(allowFieldDefaults) === false) {
        return;
      }
      // 编辑态：合计类走 initDefValue（有本值则保护至合计相对基线变化；空本值则补合计）
      if (unref(pModelObj) && unref(pModelObj).id) {
        if (unref(props).editorChange === true || isVuexTotalDefault) {
          initDefValue();
        }
        return
      }
      initDefValue();
    })
  }

  watch(() => unref(props).initDefValFlag, (newVal) => {
    nextTick(() => {
      const flag = (newVal + '');
      if (flag.indexOf('clearValue_') >= 0) {
        unref(pModelObj)[unref(model).key] = '';
      }
      const queryUserReset = pItemType === 'xmQueryForm' && ['UserSelect', 'xmUserSelect'].includes(componentKey);
      if (queryUserReset && flag.indexOf('formResetFields_') >= 0) {
        return;
      }
      // 自定义方案下：仅允许重置类 flag 回填字段默认值，其它场景不自动补默认
      if (
        unref(allowFieldDefaults) === false &&
        flag.indexOf('formResetFields_') < 0 &&
        flag.indexOf('schemeDefaultRestore_') < 0
      ) {
        return;
      }
      initDefValue();
    })
  })

  if (unref(initDefValFlag) != null) {
    watch(initDefValFlag, () => {
      initDefValue();
    })
  }


  return {}
}
